module.exports = __webpack_public_path__ + "img/youtube-phone.a758c273.png";